import apiClient from './api';

export const authService = {
  login(formData) {
    return apiClient.post('/auth/token', formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  },

  getProfile() {
    return apiClient.get('/auth/me');
  },

  changePassword(payload) {
    return apiClient.post('/auth/change_password', payload);
  }
};
